import React from 'react';
import ReactDOM from 'react-dom/client';
import NoPage from './pages/NoPage';
import Page from './pages/Page';
import Layout from './Layout';
import Image from './pages/Image';
import { BrowserRouter, Routes, Route } from 'react-router-dom';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
     <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
            <Route path="" element={<Page />} />
            <Route path="404" element={<NoPage />} />
            <Route path="item/:slug" element={<Image />} />
            <Route path="*" element={<Page />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

